import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { UserGuideModel } from '@reducers/orm/user-guide/user-guide.model';

export interface UserGuideState extends EntityState<UserGuideModel> {
  loaded: boolean;
}

export const userGuideModelEntityAdapter: EntityAdapter<UserGuideModel> = createEntityAdapter<UserGuideModel>({
  selectId: (model) => model.guide,
});

export const initialState: UserGuideState = userGuideModelEntityAdapter.getInitialState({
  loaded: false,
});
